var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("소장품 관리")])]), _c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("소장품 관리 컨설팅")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "page-text primary--text"
  }, [_c('p', [_vm._v("본 서비스는 기업, 기관, 미술관, 박물관, 문화시설 등에 제공됩니다.")]), _c('p', [_vm._v("본 서비스는 예술 작품에 대한 기업 및 기관에 방향과 지침을 제공할 수 있으며, 취득 및 처분을 통해 컬렉션의 고유한 가치를 최대한 활용할 수 있는 방법에 대해 조언합니다.")]), _c('p', {
    staticStyle: {
      "letter-spacing": "-.04em!important"
    }
  }, [_vm._v("구두로 설명하는 아래 4가지의 컨설팅은 무료로 진행됩니다. 부담없이 문의해 주시기 바랍니다.")]), _c('p', [_vm._v("다만, 서류 혹은 문서(보고서) 형식으로 제공받고자 하는 경우에는 유료로 진행됩니다.")])])])], 1)], 1)]), _c('v-divider', {
    staticClass: "grey-cb"
  }), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "my-n14 my-md-n20"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-collection-img.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v(" 소장품 구입 컨설팅 "), _c('v-divider', {
    staticClass: "grey-da h-10px mx-6 my-auto mx-md-10",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("Acquisitions")])], 1)]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("당사에서는 의뢰받은 뮤지엄 및 기업에 대한 소장품을 분석합니다. 이를 통하여,")]), _c('ul', {
    staticClass: "letter-list mt-4 mt-md-6"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("부족하거나 보강이 필요한 소장품의 범위 제시")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("미션 및 수집전략에 부합할 수 있는 수집범위 및 특성화 방안")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("소장품 수집의 원칙 및 철학, 예산 및 지역사회 고려사항 등을 제시합니다.")])])]), _c('p', {
    staticClass: "page-text mt-4 mt-md-6"
  }, [_vm._v("이러한 과정을 통하여 의뢰 뮤지엄 및 기업은 최적의 소장품을 취득할 수 있으며, 지속 가능한 조직의 성장을 도모할 수 있습니다.")])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-collection-img2.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v(" 소장품 관리 컨설팅 "), _c('v-divider', {
    staticClass: "grey-da h-10px mx-6 my-auto mx-md-10",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("Collection Management")])], 1)]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("당사에서는 소장처 혹은 소장가의 상황 및 여건에 부합되는 최적의 소장품 관리방안을 아래와 같은 내용으로 조언합니다.")]), _c('ul', {
    staticClass: "letter-list mt-4 mt-md-6"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("개별 작품에 대한 보관 및 관리 방안")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("소장품 보관 환경 및 시설, 보존 및 보존처리 방안")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("문서 관리 및 시스템 관리 방안")])])]), _c('p', {
    staticClass: "page-text mt-4 mt-md-6"
  }, [_vm._v("이러한 과정을 통하여, 관리비용 절감, 인력 효율화, 방안")])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-collection-img3.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v(" 소장품 처분 컨설팅 "), _c('v-divider', {
    staticClass: "grey-da h-10px mx-6 my-auto mx-md-10",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("Deaccessioning")])], 1)]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("코로나 영향으로 국내외의 많은 뮤지엄과 문화기관은 경제적인 어려움을 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("경험한 바 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("사립 뮤지엄의 컬렉션은 긴박한 경영상의 사유가 발생하였을 경우, 처분할 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("이러한 뮤지엄의 컬렉션은 미술시장에 신선한 관심을 불러 일으킬 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터옥션에서는 소장품 처분의 사유, 방법, 절차 등에 대한 전문적인 조언을 해 드립니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-collection-img4.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v(" 소장품 중장기 전략 컨설팅 "), _c('v-divider', {
    staticClass: "grey-da h-10px mx-6 my-auto mx-md-10",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("Long Term Strategic Plan")])], 1)]), _c('div', [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("한 번 수집한 소장품은 장구한 기간동안 함께 해야 합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("현재 보유있는 소장품은 자산관리 및 활용 측면에서 깊이 있는 전략을 수립해야 합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터옥션의 <소장품 중장기 전략 서비스>는 귀사의 컬렉션 매니지먼트에 새로운 생동감을 부여할 수 있을 것입니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])])], 1)], 1)])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }